import type { CategoryContent } from '../row.js';

export const LYMPHATIC_NERVOUS: CategoryContent = {
  bscba: [
    [
      'Wat is de primaire functie van lymfeknopen?',
      [
        'Lymfe filteren en immuunresponsen genereren',
        'Bloedsuiker opslaan en reguleren',
        'Rode bloedcellen produceren voor zuurstoftransport',
        'Spijsverteringsenzymen in het maagdarmkanaal afscheiden',
      ],
      0,
      'Lymfeknoppen filteren antigenen en pathogenen en zijn plaatsen van B- en T-celactivering. Ze zijn geen endocriene of hematopoëtische organen.',
    ],
    [
      'Welke structuur in de lymfeknoop is verantwoordelijk voor het naar binnen brengen van lymfe?',
      [
        'Afferente lymfatische vaten',
        'Efferente lymfatische vaten',
        'Subcapsulaire sinus',
        'Medullaire koorden',
      ],
      0,
      'Afferente lymfatische vaten voeren lymfe de knoop in; efferente vaten voeren deze uit. De sinussen zijn ruimtes waar filtratie optreedt.',
    ],
    [
      'Het centraal zenuwstelsel bestaat uit welke twee organen?',
      [
        'De hersenen en het ruggenmerg',
        'De hersenen en craniale zenuwen',
        'Het ruggenmerg en perifere ganglia',
        'De kleine hersenen en autonome ganglia',
      ],
      0,
      'Het CZS bestaat uit hersenen en ruggenmerg. Alle andere neurale structuren, inclusief zenuwen en ganglia, behoren tot het perifeer zenuwstelsel.',
    ],
    [
      'Welk type lymfocyt rijpt in de thymus?',
      [
        'T-lymfocyten (T-cellen)',
        'B-lymfocyten (B-cellen)',
        'Natural killer-cellen',
        'Geheugen-cellen',
      ],
      0,
      'T-cellen ontwikkelen zich in de thymus voordat zij naar lymfoïde organen migreren. B-cellen rijpen in het beenmerg; NK-cellen in beenmerg en thymus.',
    ],
    [
      'Wat is een synaps?',
      [
        'De verbinding tussen een neuron en een andere excitabele cel',
        'Het gebied van een neuron dat elektrische signalen van andere neuronen ontvangt',
        'Een soort ionkanaal gevonden in celmembranen van zenuwen',
        'De beschermende schede rond axonen in het perifeer zenuwstelsel',
      ],
      0,
      'Een synaps is waar pre- en postsynaptische cellen zich ontmoeten voor chemische of elektrische transmissie. Dendriten ontvangen signalen; synapsen maken hun overdracht mogelijk.',
    ],
    [
      'De thoracale ductus voert lymfe af van welk lichaamsgebied?',
      [
        'De linkerzijde van het lichaam en de meeste buikorganen',
        'Alleen de rechterbovenzijde en rechterkant van de thorax',
        'Alleen de benen en onderbuik',
        'Alleen hoofd- en halsregio\'s',
      ],
      0,
      'De thoracale ductus voert het merendeel van het lichaam af. De rechter lymfatische ductus voert alleen de rechterarm, rechter thorax en rechts hoofd/nek af.',
    ],
    [
      'Welke van de volgende is GEEN craniale zenuw?',
      [
        'De glossofaryngeale zenuw',
        'De vaguszenuw',
        'De femorale zenuw',
        'De hypoglossale zenuw',
      ],
      0,
      'De femorale zenuw ontspringt uit het lumbale ruggenmerg (L2-L4), waardoor het een spinale zenuw is. Glossofaryngeaal, vagus en hypoglossaal zijn craniale zenuwen (IX, X, XII).',
    ],
    [
      'Wat doen neurotransmitters op de synaps?',
      [
        'Signalen naar de postsynaptische cel overbrengen',
        'Actiepotenties in het axoninitiaalgebied genereren',
        'Heropname van ionen uit de synaptische spleet voorkomen',
        'De myeline-schede rond axonen versterken',
      ],
      0,
      'Neurotransmitters worden door de presynaptische terminal vrijgegeven en binden receptoren op de postsynaptische cel. Ze genereren geen actiepotenties en beïnvloeden geen myeline.',
    ],
    [
      'Welk gebied van een lymfeknoop wordt vooral bevolkt door T-lymfocyten?',
      [
        'De paracortex (diepe cortex)',
        'De follikels en keimcentra',
        'De medullaire koorden',
        'De subcapsulaire sinus',
      ],
      0,
      'T-cellen bevinden zich in de paracortex. B-cellen vullen follikels en keimcentra; plasmacellen bezetten medullaire koorden; sinus filtert lymfe.',
    ],
    [
      'Wat is de functie van de myeline-schede?',
      [
        'De snelheid van axongeleiding verhogen',
        'Voorkomen dat het axon synapsen vormt',
        'Glucose opslaan voor neuronenergiestofwisseling',
        'Neurotransmitters in het axonterminal synthetiseren',
      ],
      0,
      'Myeline maakt saltatorische geleiding mogelijk en verhoogt de actiepotentiaalsnelheid aanzienlijk. Het synthetiseert niets, voorkomt geen synapsen en slaat geen energie op.',
    ],
    [
      'Welke van de volgende beschrijft het beste de relatie tussen lymfatische en bloedcapillairen?',
      [
        'Lymfatische capillairen voeren ontsnapt interstitieel vocht terug naar het bloed',
        'Lymfatische capillairen produceren plasma-eiwitten waarvan bloedcapillairen afhangen',
        'Bloedcapillairen draineren rechtstreeks in lymfatische vaten zonder interstitiële ruimte',
        'Lymfatische capillairen transporteren zuurstof en glucose terwijl bloedcapillairen immuuncellen transporteren',
      ],
      0,
      'Lymfatische capillairen herstellen vloeistof en eiwitten die uit bloedcapillairen in het interstitium lekken en voeren deze terug naar het veneuze systeem.',
    ],
    [
      'Wat is de rol van het parasympathische zenuwstelsel?',
      [
        '"Rust en vertering" reacties bevorderen',
        'Hartslag en bloeddruk verhogen als reactie op bedreigingen',
        'Vrijwillige spiercontractie controleren',
        'De productie van hormonen in de hypothalamus reguleren',
      ],
      0,
      'Het parasympathische systeem bevordert rust, vertering en herstel (via de vaguszenuw en sacrale uitstroom). Het sympathische systeem activeert vecht-of-vluchtreacties.',
    ],
    [
      'Lymfocyt-homing naar specifieke lymfoïde organen wordt primair geleid door welke moleculen?',
      [
        'Adhesiemoleculen en chemokinen',
        'Hormonen uitgescheiden door de bijnier',
        'Neurotransmitters vrijgegeven door sympathische zenuwuiteinden',
        'Antilichamen geproduceerd door plasmacellen',
      ],
      0,
      'Adhesiemoleculen (selectines, integrines) en chemokinen vormen een gradiëntsysteem dat lymfocytenverkeer leidt. Hormonen, neurotransmitters en antilichamen hebben andere rollen.',
    ],
    [
      'Welk van deze structuren maakt deel uit van het perifeer zenuwstelsel?',
      [
        'Spinale en craniale zenuwen',
        'De hersenenschors',
        'De hersenstam',
        'De kleine hersenen',
      ],
      0,
      'Spinale en craniale zenuwen zijn het PZS. Hersenstructuren (cortex, stam, cerebellum) behoren tot het CZS.',
    ],
    [
      'Waaruit bestaat lymfe primair?',
      [
        'Gefilterd bloedplasma met eiwitten en immuuncellen',
        'Rode bloedcellen en hemoglobine in suspensie',
        'Gal zouten en spijsverteringsenzymen',
        'Cerebrospinaalvocht dat uit de hersenen is weggelekt',
      ],
      0,
      'Lymfe is in wezen gefilterd bloedplasma plus immuuncellen. Het bevat veel minder eiwitten dan plasma maar veel meer lymfocyten dan bloed.',
    ],
  ],
  msc: [
    [
      'Hoe accumuleren T-cellen bij voorkeur in de paracortex van lymfeknopen tijdens een immuunrespons?',
      [
        'Via CCR7-signalering die T-cellen van bloed naar de paracortex leidt',
        'Via willekeurige migratie; T-cellen hebben geen voorkeurverkeerssignaal',
        'Door actief te worden getransporteerd door dendritische cellen die ze van cortex naar paracortex dragen',
        'Via CXCL12-gradiënten die exclusief rond het keimcentrum voorkomen',
      ],
      0,
      'T-cellen drukken CCR7 uit en volgen CCL19/CCL21-gradiënten uitgescheiden door fibroblastische reticulaire cellen in paracortex. Dit is het primaire homingmechanisme.',
    ],
    [
      'Wat is de juiste anatomische relatie tussen Peyer-plekken en lymfatische drainage?',
      [
        'Peyer-plekken zijn darmgeassocieerd lymfoïd weefsel dat draineert naar mesenterische lymfeknopen',
        'Peyer-plekken zijn lymfeknopen in het mesenterium die rechtstreeks met bloedvaten verbonden zijn',
        'Peyer-plekken produceren lymfe rechtstreeks in het darmlumen',
        'Peyer-plekken hebben geen lymfatische drainage; antigenen worden rechtstreeks in het bloed opgenomen',
      ],
      0,
      'Peyer-plekken nemen darmantígenen op en draineren via afferente lymfatische vaten naar mesenterische knoppen, dan via efferente vaten naar thoracale ductus.',
    ],
    [
      'Wat is het structurele verschil tussen een multipolair en een bipolair neuron?',
      [
        'Multipolaire neuronen hebben meerdere dendrieten; bipolaire hebben er één',
        'Multipolaire neuronen zenden signalen sneller door dan bipolaire neuronen',
        'Bipolaire neuronen worden alleen in het ruggenmerg gevonden; multipolair in de hersenen',
        'Multipolaire neuronen gebruiken acetylcholine; bipolaire neuronen dopamine',
      ],
      0,
      'Multipolaire neuronen hebben één axon en meerdere dendriten (meest voorkomend); bipolaire neuronen hebben één axon en één dendriet (zintuigsystemen, netvlies).',
    ],
    [
      'Hoe reguleert de bloed-hersenbarrière de ingang van immuuncellen in het CZS?',
      [
        'Strakke juncties beperken transport; adhesiemoleculen staan selectieve leukocyt-passage toe',
        'De bloed-hersenbarrière is volledig doorlaatbaar voor alle immuuncellen zonder regulatie',
        'Immuuncellen dringen nooit het CZS in, zelfs niet bij ontsteking',
        'Alle immuuncellen worden vrij gefilterd in cerebrospinaalvocht door het plexus choroideus',
      ],
      0,
      'Strakke juncties in het BBB-endotheel beperken paracellulair transport strikt. Integrines en selectines op geactiveerde leukocyten maken selectieve transendotheliale migratie mogelijk.',
    ],
    [
      'Welk neurotransmittersysteem is primair verantwoordelijk voor de sympathische signalering naar doelorganen?',
      [
        'Noradrenaline werkend op alfa- en bèta-adrenerge receptoren',
        'Acetylcholine werkend alleen op nicotinische receptoren',
        'Gamma-aminoboterzuur (GABA) op remmende synapsen',
        'Serotonine in de dorsale raphe kern',
      ],
      0,
      'Sympathische postganglionische neuronen geven noradrenaline af (behalve bij zweetklieren/bijniermerg, waar acetylcholine wordt gebruikt). GABA en serotonine hebben andere CZS-rollen.',
    ],
    [
      'Wat is de functionele betekenis van High Endothelial Venules (HEVs) in lymfeknopen?',
      [
        'Postcapillaire venules die lymfocytenextravasatie in de knoop mogelijk maken',
        'Bloedvaten die rechtstreeks met afferente lymfatische vaten verbonden zijn',
        'Venules die lymfe van medullaire koorden terug naar de circulatie transporteren',
        'Vaten die verantwoordelijk zijn voor drainage van de knoop via efferente lymfatische vaten',
      ],
      0,
      'HEVs drukken L-selectine-liganden en ICAM-1/VCAM-1 uit; naïeve lymfocyten verlaten het bloed via HEVs door selectine-gemedieerde rolling en integrine-binding.',
    ],
    [
      'Hoe beïnvloedt de vaguszenuw (CN X) immuunresponsen in de darm en andere organen?',
      [
        'Parasympathische vezels geven acetylcholine af en moduleren ontsteking',
        'De vaguszenuw heeft geen relatie met immuunfunctie; het controleert alleen spijsvertering',
        'Het verhoogt ontsteking door TNF-alfa en IL-6 vrij te geven',
        'Het blokkeert alle lymfocytenactivering via sympathomimetische wegen',
      ],
      0,
      'De vaguszenuw geeft acetylcholine af, wat via het cholinergisch anti-inflammatoir pad macrofaag TNF-alfa-productie remt en IL-10 bevordert.',
    ],
    [
      'Wat is de anatomische basis voor de bloed-CSF-barrière op het plexus choroideus?',
      [
        'Strakke juncties tussen epitheelcellen van de plexus choroideus',
        'Een ondoordringbare beenbarrière die bloed van cerebrospinaalvocht scheidt',
        'Volledige menging van bloed en CSF zonder barrièrefunctie',
        'Een laag arachnoïdale cellen die fysiek alle moleculen belemmert',
      ],
      0,
      'Het epitheel van de plexus choroideus handhaaft strakke juncties en drukt transporters uit voor selectieve opname van voedingsstoffen en uitsluiting van pathogenen uit CSF.',
    ],
    [
      'Welke craniale zenuwen (CN) voeren parasympathische vezels naar het oog?',
      [
        'CN III (oculomotorzenuw) innerveert de ciliairemusculatuur en de pupilsphincter',
        'CN V (trigeminuszenuw) controleert alle oogbewegingen en pupilresponsen',
        'CN VI (abducenszenuw) stuurt de pupil en lensaccommodatie aan',
        'CN VII (aangezichtszenuw) is de enige parasympathische bron naar het oog',
      ],
      0,
      'De parasympathische pregangliaire vezels van CN III maken synaps in het ciliaire ganglion; de postganglionische vezels innerveren de ciliairemusculatuur (accommodatie) en de sphincter pupillae (constrictie).',
    ],
    [
      'Wat is de route van lymfatische drainage van de rechterbovenarm en rechter thorax?',
      [
        'Via de rechter lymfatische ductus, die uitmondt in de rechter vena subclavia',
        'Via de thoracale ductus in de linker vena subclavia',
        'Rechtstreeks in de bovenste holle ader zonder enige ductus te passeren',
        'In de rechter interne jugulaire ader en dan naar het rechter atrium',
      ],
      0,
      'De rechter lymfatische ductus voert de rechterarm, rechter thorax en rechts hoofd/nek af en voegt zich bij het veneuze systeem aan de rechter veneuze hoek.',
    ],
    [
      'Wat is de microarchitectuur van een secundaire follikel in een lymfeknoop?',
      [
        'Een donker keimcentrum omgeven door een lichtere mantelzone van naïeve B-cellen',
        'Het is een willekeurige aggregatie van lymfocyten zonder georganiseerde zones',
        'Het bestaat uit een enkele laag epitheelcellen',
        'Het is gelokaliseerd in de medullaire regio en is vrij van B-cellen',
      ],
      0,
      'Secundaire follikels tonen keimcentra (GC\'s) met prolifererende centroblasten en somatische hypermutatie; de mantelzone omgeeft de GC.',
    ],
    [
      'Welk ruggenmerg-kanaal voert pijn- en temperatuurgevoel van de contralaterale lichaamszijde?',
      [
        'Het spinothalamische kanaal, dat in het ruggenmerg kruist',
        'De dorsale kolom (fasciculus gracilis en cuneatus)',
        'Het corticospinale kanaal (motorisch, niet sensorisch)',
        'Het vestibulocerebellaire kanaal',
      ],
      0,
      'Pijn/temperatuur-axonen maken synaps in de dorsale hoorn, kruisen in het ruggenmerg en stijgen als contralateraal spinothalamisch kanaal naar de thalamus.',
    ],
    [
      'Hoe beïnvloedt neuro-ontsteking door microgliale activering de CZS-immuunrespons?',
      [
        'Geactiveerde microglia geven cytokinen af en presenteren antigeen',
        'Microglia verwijderen alleen puin en hebben geen rol in ontsteking',
        'Microglia blokkeren alle immuunresponsen in de hersenen permanent',
        'Microglia produceren alleen anti-inflammatoire mediatoren',
      ],
      0,
      'Microglia zijn CZS-inwonende macrofagen die gevaar via PRR\'s voelen, cytokinen produceren en antigeen presenteren. Ze zijn cruciaal voor neuraal-inflammatoire pathologie.',
    ],
    [
      'Welke moleculen leiden B-cellen specifiek naar follikels in lymfeknopen?',
      [
        'CXCL13-CXCR5-signalering creëert een chemoatactische gradiënt naar B-cel-zones',
        'CCL19 en CCL21, die ook T-cellen leiden',
        'Antigenen zelf trekken B-cellen rechtstreeks naar follikels',
        'Fibroblastische reticulaire cellen die B-cellen fysiek naar follikels duwen',
      ],
      0,
      'B-cellen drukken CXCR5 uit en volgen CXCL13-gradiënten geproduceerd door follikulaire dendritische cellen in keimcentra en follikels.',
    ],
    [
      'Wat is de structurele en functionele rol van de glomerulaire filtratie barrière (GFB) in immuun-bewaking van de nieren?',
      [
        'Een zeer selectief filter dat grote eiwitten en cellen blokkeert',
        'De GFB is volledig doorlaatbaar voor alle immuuncellen voor constante nierpatrouille',
        'De GFB heeft geen immuunfunctie; het filtert alleen metabolische afvalstoffen',
        'De GFB transporteert immuun-complexen actief in de urine ter verwijdering',
      ],
      0,
      'De GFB (endotheel, basaalmembraan, podocyten) beperkt de passage van eiwitten en cellen, terwijl het immuun-bewaking wel toestaat. Verstoring veroorzaakt proteïnurie.',
    ],
  ],
  phd: [
    [
      'Welke rol speelt de productie van lymfangiogene factoren door lymfatische endotheelcellen (LEC\'s) in immuun-verkeer en de resolutie van ontsteking?',
      [
        'LEC\'s scheiden VEGF-C/D uit om lymfangiogenese te bevorderen tijdens resolutie',
        'LEC\'s voorkomen actief lymfangiogenese door anti-VEGF moleculen uit te scheiden',
        'Lymfangiogenese vertraagt ontsteking oneindig',
        'LEC\'s hebben geen actieve rol in immuun-verkeer; zij zijn slechts passieve geleiders',
      ],
      0,
      'VEGF-C/D-geïnduceerde lymfangiogenese verhoogt lymfeflow en T-cel-egress, wat antigeen- en geactiveerde lymfocyten-opruiming versnelt.',
    ],
    [
      'Hoe integreren patroonherkenningsreceptoren (PRR\'s) op weefsel-inwonende dendritische cellen en lymfatisch endotheel aangeboren detectie rechtstreeks met lymfatisch verkeer?',
      [
        'TLR\'s op LEC\'s voelen PAMP\'s en verhogen chemokinen en adhesiemoleculen',
        'PRR\'s werken alleen in bloed; LEC\'s zijn PRR-negatief',
        'PRR-signalering onderdrukt alle lymfocyt-rekrutering naar afvoerknopen',
        'PRR\'s worden exclusief op T-cellen gevonden, niet op stromale of endotheelcellen',
      ],
      0,
      'TLR-signalering op LEC\'s en antigen-presenterende cellen induceert chemokine en integrine-ligand upregulering, wat de inflammatoir knooprespons versterkt.',
    ],
    [
      'Hoe is een dorsale worteleganglion (DRG) structureel georganiseerd om immuun-celtoegang te reguleren?',
      [
        'DRG-soma\'s worden beschermd door satellietgliële cellen en een fibroblastische capsule',
        'DRG\'s zijn immuun-geprivilegieerd en ervaren nooit immuun-celinfiltratie',
        'DRG\'s missen enige georganiseerde structuur of immuun-barrière',
        'De DRG-capsule is functioneel identiek aan de bloed-hersenbarrière',
      ],
      0,
      'DRG-soma\'s worden beschermd door satellietgliële cellen en fibroblastische capsule. Immuun-celinfiltatie breekt deze barrière via capsulair verbreken.',
    ],
    [
      'Hoe stelt de topologie van lymfatische capillairen (met overlappende endotheelverbindingen en gebrek aan strakke juncties) selectieve opname van lymfatische antigenen en verkeer mogelijk?',
      [
        'Overlappende juncties laten immuuncellen en antigeen in lymfe binnentreden',
        'Strakke juncties in lymfatische capillairen voorkomen alle antigeen-opname',
        'Lymfatische capillairen pompen actief antigenen tegen diffusie in zichzelf',
        'Antigenen worden alleen in bloedcapillairen opgenomen, niet in lymfatische capillairen',
      ],
      0,
      'Lymfatische capillaire juncties laten interstitiële vloeistof, immuuncellen en antigenen passief binnentreden. Macrofagen en dendritische cellen nemen antigenen op.',
    ],
    [
      'Wat is de moleculaire en cellulaire basis voor immuun-tolerantie voor commensale antigenen in mesenterische lymfeknopen (mLN\'s), versus geactiveerde reacties op pathogene antigenen?',
      [
        'Commensaal-antigenen induceren tolerogene DC\'s die regulerende T-cellen bevorderen',
        'Alle antigenen uit de darm worden onmiddellijk afgewezen ongeacht bron',
        'De mLN\'s hebben geen capaciteit om commensalen van pathogenen te onderscheiden',
        'Commensaal-antigenen triggeren dezelfde inflammatoire reactie als pathogene antigenen',
      ],
      0,
      'Tolerogene DC\'s (CD103+ CD11b+ gevoed door TGF-beta-producerende epitheelcellen) bevorderen iTregs in mLN\'s. Pathogene DC\'s scheiden IL-12/IL-23 uit.',
    ],
    [
      'Hoe reguleert purinerge signalering (ATP/ADP) via P2X7-receptoren op immuuncellen lymfatisch verkeer en ontsteking?',
      [
        'ATP activeert P2X7, wat inflammasoom-activering en IL-1beta-afgifte veroorzaakt',
        'Purinerge signalering is irrelevant voor immuun-verkeer',
        'P2X7-activering onderdrukt alle immuunresponsen en voorkomt lymfeknoop-activering',
        'ATP werkt alleen in neuronale synapostransmissie, niet immuun-signalering',
      ],
      0,
      'P2X7-gemedieerde IL-1beta versterkt ontsteking. Het bevordert ook leukocyt-rekrutering naar ontstoken weefsels en hun egress via lymfatieken naar afvoerknopen.',
    ],
    [
      'Welke rol spelen calcitonine-gerelateerd peptide (CGRP) en neuropeptiden bij het reguleren van immuun-celverkeer via sympathische lymfeknoop-innervatie?',
      [
        'CGRP en stof P van zenuwuiteinden moduleren immuun-celverkeer',
        'Neuropeptiden hebben geen rol in immuun-celverkeer',
        'CGRP beïnvloedt uitsluitend pijngewaarwording; het beïnvloedt immuniteit niet',
        'Sympathische innervatie van lymfeknopen voorkomt al het immuun-verkeer',
      ],
      0,
      'Sympathische zenuwuiteinden in lymfeknopen geven CGRP en NE af, wat vasculariteit, stromale celfunctie en immuun-cel behoud/egress moduleert.',
    ],
    [
      'Hoe coördineren folliculaire helper-T-cellen (Tfh) en folliculaire dendritische cellen (FDC\'s) keimcentrumreacties in lymfeknopen, en welke lymfatische factoren ondersteunen deze micro-omgeving?',
      [
        'FDC\'s presenteren antigeen en VEGF-C breidt lymfatieken uit',
        'Tfh en FDC\'s zijn niet functioneel onderling verbonden',
        'Keimcentra vereisen geen lymfatische ondersteuning',
        'Tfh remmen FDC-functie en storten keimcentra in',
      ],
      0,
      'Tfh-FDC-interactie stimuleert somatische hypermutatie en selectie; lymfangiogenese past immuun-celexpansie en lymfocyt-egress uit groeiende knoppen aan.',
    ],
    [
      'Wat is de functionele rol van circumventriculaire organen zoals het subforniculaire orgaan (SFO) en organum vasculosum laminae terminalis (OVLT) in immuun-detectie?',
      [
        'Deze organen missen een bloed-hersenbarrière, wat immuun-bewaking van het bloed toestaat',
        'Deze structuren zijn louter sensorische organen voor bloedosmolariteit; zij hebben geen immuunfunctie',
        'De bloed-hersenbarrière werkt volledig op deze plaatsen',
        'Deze organen scheiden immuunsuppressieve factoren uit die alle CZS-immuunresponsen blokkeren',
      ],
      0,
      'CVO\'s zijn BBB-loze plaatsen waar tanycyten en inwonende dendritische cellen circulerend IL-1, TNF-alfa en LP voelen en dit aan de hypothalamus signaleren.',
    ],
    [
      'Hoe integreren huid-inwonergeheugen T-cellen (TRM) in epidermis met lymfatisch verkeer in context van secundaire uitdaging?',
      [
        'TRM volharden via IL-15 en rekruteren aangeboren cellen naar afvoerknopen',
        'Huid TRM worden onmiddellijk in lymfatieken gespoeld bij antigeen-ontmoeting',
        'TRM leveren geen beschermende functie en worden vervangen door circulerende geheugen-cellen',
        'Lymfatieken ontbreken in huid; TRM werken in immuunologische isolatie',
      ],
      0,
      'TRM (CD69+ CD103+) bieden snelle lokale controle; gerekruteerde aangeboren cellen verspreiden zich via afferente lymfatieken om systeemresponsen in afvoerknopen te versterken.',
    ],
    [
      'Welke rollen spelen periaqueductale grijs (PAG) en retrorubrale kern (RRN) in nociceptieve signalering en immuun-pijninteracties?',
      [
        'PAG moduleert pijnpoorten; RRN medieert analgesie',
        'Deze structuren controleren alleen motorbewegingen, niet pijn of immuniteit',
        'De PAG heeft geen relatie tot immuunfunctie',
        'Nociceptieve wegen omzeilen de hersenstam helemaal',
      ],
      0,
      'PAG integreert pijn en dreiging; RRN-gemedieerde afstammende remming poort nociceptieve overdracht. Beide activeren HPA-as en sympathische immuun-suppressie.',
    ],
    [
      'Wat is de rol van medullaire thymusepitheelcellen (mTEC\'s) en AIRE in centrale tolerantie en lymfatische drainage van apoptotische lymfocyten in de thymus?',
      [
        'AIRE+ mTEC\'s elimineren autoreactieve thymocyten via medullaire lymfatische opruiming',
        'mTEC\'s hebben geen rol in tolerantie; zij bieden alleen structuurondersteuning',
        'AIRE voorkomt alle T-celrijping en blokkeert lymfatische drainage',
        'Apoptotische cellen hopen zich oneindig op in de medullaire thymus zonder drainage',
      ],
      0,
      'AIRE+ mTEC\'s presenteren zelf-antigenen voor negatieve selectie. Medullaire lymfatieken (mlEC\'s die CCL21 uitdrukken) staan Treg-egress en apoptotische cel-opruiming toe.',
    ],
    [
      'Hoe reguleren oplosbare mediatoren vrijgegeven tijdens neurogenische ontsteking (via TRPV1+ sensorische neuronen) de samenstelling en verkeer van lokale aangeboren immuuncellen en hun migratie in afvoerlymfatieken?',
      [
        'Sensorische neuropeptiden activeren mastcellen en drijven chemokine-gemedieerde rekrutering',
        'Sensorische neuropeptiden voorkomen alle immuun-cel-rekrutering',
        'Neurogenische ontsteking is onafhankelijk van immuun-celverkeer',
        'Stof P en CGRP controleren uitsluitend pijn; zij hebben geen immuunologische rol',
      ],
      0,
      'Sensorische peptiden-afgifte stimuleert mastcel-ontladingen, endotheelpermeabiliteit en chemokine-productie, wat lokale aangeboren ontsteking en lymfatisch verkeer versterkt.',
    ],
    [
      'Hoe blijft immuun-geheugen behouden op het niveau van lymfeknoop-stroma-architectuur en langdurige plasmacel (LLPC)-nichen in beenmerg?',
      [
        'Beenmerg-LLPC-nichen ondersteunen antilichamen onafhankelijk van recirculatie',
        'Immuun-geheugen wordt uitsluitend in bloed opgeslagen; lymfeknopen zijn inactief na infectie',
        'Beenmerg plasma-cellen vereisen continue antigeen-circulatie via lymfatieken',
        'Lymfeknoop-stroma-architectuur levert geen geheugenfunctie',
      ],
      0,
      'LLPC\'s vestigen beenmerg-nichen (IL-6, CXCL12 van osteoblasten/CAF\'s) en volharden zonder actief antigeen. Geheugen-B-cellen recirculeren en bemonsteren lage antigeenniveaus in FDC\'s.',
    ],
    [
      'Hoe reguleren Sphingosine-1-fosfaat (S1P) gradiënten over lymfeknoop-grenzen lymfocyt-egress versus retentie, en wat is de rol van S1P1-receptorsignalering in thymus-egress van ontwikkelende T-cellen?',
      [
        'S1P1-signalering langs een bloed-lymfoïde gradiënt stimuleert T-cel-uitgang',
        'S1P werkt alleen in barrièrelipidstofwisseling; het heeft geen signaleringsrol in immuniteit',
        'S1P-gradiënten zijn identiek binnen en buiten lymfeknopen',
        'Thymus-egress wordt uitsluitend door cortisol en bijnier-hormonen gecontroleerd',
      ],
      0,
      'S1P₁ op uitstappende T-cellen voelt lagere intranodaal S1P, stimuleert uitgang; hoog extranodaal S1P bevordert migratie naar bloed. S1P₁-antagonisten (fingolimod) vangen lymfocyten klinisch.',
    ],
  ],
  professor: [
    [
      'Welke rol speelt lymfatisch-afgeleide VEGF-C-signalering in de resolutie van tertiaire lymfoïde structuren (TLS) bij chronische ontsteking, auto-immuniteit en tumor-micro-omgevingen?',
      [
        'VEGF-C-lymfangiogenese helpt egress maar kan tumoren verspreiden',
        'Lymfatische expansie onderdrukt universeel alle immuunresponsen',
        'Lymfangiogenese speelt geen rol in TLS-biologie',
        'VEGF-C werkt alleen in ontwikkelings-lymfangiogenese, niet in homeostase-remodeling',
      ],
      0,
      'TLS-regressie correleert met lymfangiogene remodeling en antigeen-drainage. In tumoren kan TLS-geassocieerde lymfangiogenese echter ontsnapping en systemische verspreiding bevorderen. Dit illustreert context-afhankelijke immuunuitkomsten.',
    ],
    [
      'Hoe onthullen recente studies op het gebied van single-cel-transcriptomics en ruimtelijke biologie voorheen onbekende subsets van fibroblastische reticulaire cellen (FRC\'s), en hun gespecialiseerde rol bij het scheiden van T- en B-celnichen en het bepalen van priming- versus tolerantie-uitkomsten?',
      [
        'FRC-subsets tonen chemokine-profielen die tolerogene vs. inflammatoire zones creëren',
        'Alle FRC\'s zijn functioneel identiek',
        'FRC\'s zijn alleen structureel; zij hebben geen chemokine-regulerende rol',
        'Ruimtelijke organisatie van lymfeknopen is willekeurig en heeft geen immuun-uitkomsten',
      ],
      0,
      'FRC-subsets vertonen zone-specifieke chemokine/TGF-beta-signaturen (inflammatoire CXCL10+ vs. tolerogene TGF-beta+ FRC\'s), wat functionele domeinen creëert die het lot van CD4+ T-cellen sturen.',
    ],
    [
      'Hoe overlapt het "glyfatische systeem" met meningeale lymfatische vaten bij het opruimen van eiwitaggregaten en metabolische bijproducten tijdens slaap?',
      [
        'AQP4-afhankelijke glyfatische opruiming, aangevuld door meningeale lymfatieken',
        'Het glyfatische systeem is niet functioneel verbonden met lymfatieken',
        'Meningeale lymfatieken hebben geen opruimingsfunctie',
        'Slaap heeft geen relatie tot CZS-immuun-opruiming',
      ],
      0,
      'Glyfatisch-lymfatische disfunctie verslechtert amyloid-beta-opruiming tijdens slaap, wat bijdraagt aan accumulatie en neuro-ontsteking bij Alzheimer en andere proteïneaggregaat-ziektes.',
    ],
    [
      'Hoe integreren vagale afferenten microbiota-immuunsignalen bij de nucleus tractus solitarius (NTS) om systeemtolerantie en barrière-integriteit te moduleren?',
      [
        'Vagale afferenten sturen microbiële signalen naar de NTS via cholinergische output',
        'De vagus heeft geen relatie tot microbiota of immuun-barrière-functie',
        'Microbiële metabolieten activeren direct immuuncellen zonder CZS-integratie',
        'De dorsale motor-kern controleert alleen maagazuurafscheiding',
      ],
      0,
      'Vagaal-darm-immuun-integratie: de NTS integreert microbiële signalen, de dorsale motorkern activeert cholinergische submucosale output, wat de barrière en anti-inflammatoire reacties versterkt.',
    ],
    [
      'Hoe onthullen recente vooruitgangen in inzicht in lymfeknoop-lymfatieken rollen voor initiële lymfatisch endotheelcellen (iLEC\'s) in antigeen-transcytose en de "lokale controlepunt" hypothese in T-cel-primering-regulering?',
      [
        'iLEC\'s transcytoseren antigeen en produceren CCL21, wat lymfocyt-egress poort',
        'Antígeen-transcytose treedt alleen op in bloedcapillairen',
        'Initiële lymfatieken zijn niet-selectief; alle lymfocyten vertrekken onmiddellijk',
        'iLEC\'s hebben geen regelgevend rol in T-cel-responsen',
      ],
      0,
      'iLEC\'s werken als poortwachters: zij transcytoseren antigeen ten behoeve van FDC\'s en DC\'s, terwijl CCL21-afhankelijke T-cel-retentie voortijdige egress voorkomt, zodat volledige priming mogelijk is.',
    ],
    [
      'Hoe beïnvloedt "getrainde immuniteit" in weefsel-inwonende innate lymfoïde cellen (ILC\'s), via IL-22- en IL-17-crosstalk met lymfatisch endotheel, barrière-beschermende immuniteit en lymfangiogenese?',
      [
        'ILC3-afgeleide IL-22/IL-17 versterkt epitheel en breidt lymfatieken uit',
        'ILC\'s hebben geen rol in barrière-functie of lymfangiogenese',
        'IL-22 bevordert uitsluitend inflammatoire destructie',
        'Lymfatische expansie is onafhankelijk van aangeboren lymfoïde-signalering',
      ],
      0,
      'ILC3-afgeleide IL-22 versterkt epitheliale barrières en induceert VEGF-C, wat mucosale lymfatieken uitbreidt voor verbeterde antigeen-bemonstering en immuun-bewaking.',
    ],
    [
      'Hoe onthullen optogenetische en chemogenetische dissecties van onderscheidende somatosensorische wegen (bijv. C-nociceptoren vs. A-delta mechanoreceptoren) differentiële modulering van immuun-celverkeer door dorsale hoornschakelingen en rostraal spinomesencephale projecties naar PAG?',
      [
        'C-nociceptoren stimuleren stof P-vrijgave; A-delta-vezels doen dit niet',
        'Alle sensoriële modaliteiten produceren identieke immuun-effecten',
        'Nociceptoren hebben geen immuun-relevante functies buiten pijnsignalering',
        'Het spinomesencephale kanaal draagt alleen pijn, geen immuun-relevante informatie',
      ],
      0,
      'C-nociceptor-signalering triggert dorsale hoorn IL-6/TNF-alfa-vrijgave (immuun-koppeling), PAG-gemedieerde analgesie en sympathische immuun-suppressie. A-delta-vezels activeren deze as niet.',
    ],
    [
      'Welke rol spelen weefselfactor (TF) en trombine-signalering op lymfatische endotheelcellen in lymfatische fibrose en immuun-disfunctie bij long-COVID?',
      [
        'Persistente virale antigenen stimuleren TF/PAR-signalering en fibrose',
        'TF-signalering is irrelevant voor lymfatische pathologie',
        'Long-COVID is louter psychologisch zonder immuunologische basis',
        'Lymfatische fibrose draagt niet bij aan immuun-disfunctie',
      ],
      0,
      'TF-trombine-PAR-signalering stimuleert lymfatische EZM-remodeling en aangehouden ontsteking in long-COVID, perpetueert T-cel-uitputting en auto-immuun-reacties.',
    ],
    [
      'Hoe ruimen circadiane veranderingen in lymfeflow, astrocytaire AQP4-gemedieerde glyfatische activiteit en slaap-afhankelijk meningeaal immuun-celverkeer samen neuro-inflammatoire mediatoren op?',
      [
        'AQP4 en meningeale drainage bereiken piek tijdens niet-REM-slaap',
        'Circadiale ritmes hebben geen effect op lymfatische functie',
        'Meningeale lymfatieken zijn constitutief inactief tijdens slaap',
        'Neuro-inflammatoire mediatoren worden niet via lymfatische wegen opgeruimd',
      ],
      0,
      'Slaap-afhankelijke pieken in glyfatisch-lymfatische AQP4-activiteit en meninge-immuun-cel-egress ruimen neuro-inflammatoire cytokinen en pathogenen op, beschermen CZS-homeostase.',
    ],
    [
      'Hoe onthullen recente cryo-EM en structuurstudies van CXCR5 en CCR7-chemokine-receptoren op B- en T-cellen, gecombineerd met cryo-EM van hun cognate liganden (CXCL13 en CCL21) gebonden aan glycosaminoglycanen (GAG\'s) in lymfeknoop-stromamatrices, de differentiële lymfocyt-compartimentalisering en de moleculaire basis voor "ectopische" lymfoïde orgaan-vorming in auto-immuniteit?',
      [
        'GAG-gebonden gradiënten scheiden B- en T-celzones en stimuleren ectopische TLS',
        'Chemokine-receptorstructuur is irrelevant voor lymfocyt-verkeer',
        'GAG\'s hebben geen rol in chemokine-presentatie',
        'Ectopische lymfoïde structuren zijn willekeurig verdeeld met geen chemische basis',
      ],
      0,
      'GAG-gebonden CXCL13/CCL21 creëren stabiele gradiënten in FRC-matrices die B/Tfh (CXCR5+) ruimtelijk van T-cellen (CCR7+) scheiden. Dysgereguleerde GAG-chemokine-binding in auto-immuniteit stimuleert ectopische TLS.',
    ],
    [
      'Hoe verslechteren dysgereguleerde acetylcholinesynthese en parasympathische signalering via de nucleus basalis van Meynert (NBM) en het septum de cholinergische anti-inflammatoire wegen bij neuro-ontsteking in neurodegeneratieve ziektes?',
      [
        'NBM-cholinergisch verlies ontketent microgliale neuro-ontsteking',
        'Cholinergische signalering heeft geen rol in neuro-ontsteking',
        'Proteïneaggregaat-ziektes beïnvloeden de cholinergische systeemintegriteit niet',
        'NBM en septum reguleren alleen geheugen, niet immuniteit',
      ],
      0,
      'Cholinergische neurodegeneratie bij Alzheimer verwijdert remmende ACh-signalering op microglia, bevordert TNF-alfa en verslechtert glyfatische opruiming van pathogene amyloid-beta-aggregaten.',
    ],
    [
      'Hoe onthullen single-cel-multi-omics-studies (transcriptomics, ATAC-seq-toegankelijkheid van chromatine en voorspellingen van cel-cel-interacties) de lymfatische kruiscommunicatie tussen weefsel-inwonende geheugen-T-cellen, geheugen-B-cellen en lymfatische endotheelcellen bij aangehouden mucosale immuniteit? Wat is de cellulaire en moleculaire basis van getrainde mucosale immuniteit?',
      [
        'TRM-afgeleide IL-21 ondersteunt FDC-overleving en LEC VEGF-C-productie',
        'TRM-, FDC- en LEC-crosstalk is niet aantoonbaar op moleculair niveau',
        'Mucosaal geheugen is kortstondig en vereist continue antigeen-blootstelling',
        'Lymfatische expansie is antigeen-onafhankelijk en dient geen geheugen-functie',
      ],
      0,
      'TRM-afgeleide IL-21 handhaaft FDC BAFF/APRIL-productie en TGF-beta; LEC\'s breiden mucosale lymfatieken uit via VEGF-C, handhaaft duurzaam geheugen-B en getrainde ILC-populaties.',
    ],
    [
      'Hoe communiceren het enterische zenuwstelsel (ENS) en darmgeassocieerde lymfoïde weefsel (IALT) bidirectioneel via neurotrofische factoren en microbiële metaboliet-detectie?',
      [
        'Enterische neurotrofinen ondersteunen ILC\'s; AhR-signalering remt macrofaag-TNF-alfa',
        'De ENS is volledig geïsoleerd van immuun-signalering door epitheelbarrière',
        'Enterische neuronen zenuwen alleen gladde spier; zij hebben geen immuun-functie',
        'Microbiële metabolieten worden systemisch opgenomen zonder lokale mucosale signalering',
      ],
      0,
      'ENS-IALT-integratie: neurotrofine-ILC-signalering, AhR-ligand-vagale afferent-detectie en cholinergische parasympathische output creëren samen mucosale anti-inflammatoire homeostase.',
    ],
    [
      'Wat is het opkomende inzicht in het meningeale immuunlandschap en de rollen van meningeale lymfatieken, stromale cellen en grens-geassocieerde macrofagen in CZS-immuun-tolerantie versus neuro-immuun-activering?',
      [
        'Meningeale lymfatieken maken antigeen-drainage mogelijk terwijl stromale cellen en BAM\'s tolerantie handhaven',
        'De meninges zijn immuun-geprivilegieerd; geen immuuncellen bevinden zich daar',
        'Meningeale lymfatieken dragen niet bij aan CZS-immuun-tolerantie',
        'Grens-geassocieerde macrofagen ontstaan uitsluitend uit circulerende monocyten, zonder ontwikkelingspad van dooierzakmacrofagen',
      ],
      0,
      'Meningeale LV\'s en tolerogene BAM/stromale signalering handhaven de CZS-immuunprivileges. Verlies verzwakt de tolerantie en verergert CZS-auto-immuniteit en neuro-ontsteking.',
    ],
    [
      'Hoe beschermen circadiale immuun-oscillaties, meningeale lymfatische pulsatiliteit en slaap-fase-afhankelijke glyfatische CSF-ISF-uitwisseling samen tegen neurodegeneratie?',
      [
        'Circadiale egress, meningeale pulsatiliteit en NREM-opruiming beschermen neuronen',
        'Circadiale ritmes zijn irrelevant voor lymfatische of glyfatische functie',
        'Lymfatische pulsatiliteit is onafhankelijk van slaap-cycli',
        'Neurodegeneration wordt niet beïnvloed door slaapkwaliteit of immuun-drainage-patronen',
      ],
      0,
      'Circadiale-immuun-glyfatische integratie: nachtpieken in lymfocyt-egress, NREM meningeale LV-pulsatiliteit en AQP4-gemedieerde CSF-opruiming maximaliseren samen de neuroprotectie.',
    ],
  ],
};
